<template lang="pug">
template(v-if="!isTablet && slots")
	slot(v-for="item in slots" :name="item")
template(v-else="")
	.v-mob-acc.mob-acc
		.mob-acc__item(v-for="item in slots" :style="{'background': options[item]?.background}")
			.mob-acc__head(v-if="options[item]" @click="active = active === item ? null : item")
				.mob-acc__title(:style="{'color': options[item]?.color}") {{options[item].title}}
				.mob-acc__btn
					v-svg-icon.mob-acc__btn-icon(:icon="active === item ? 'minus' : 'plus'")
			.mob-acc__item-body(:id="'body' + item" :style="{'height': active === item ? getHeight(item) : 0}" )
				slot(:name="item")
</template>

<script>

import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import {nextTick} from "vue";

export default {

	mixins: [
		isMobMixin
	],

	props: {
		options: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			slots: null,
			active: null
		}
	},

	async mounted() {
		await nextTick()
		this.slots = Object.keys(this.$slots);
		let active = null;
		Object.entries(this.options)?.findIndex(item => {
			if (item[1]?.active) {
				active = item[0]
			}
		})
		this.active = active || this.slots[0];
	},

	methods: {
		getHeight(id) {
			return document.getElementById('body' + id)?.scrollHeight + 'px';
		}
	}
}
</script>